



























































import { Component, Vue } from 'vue-property-decorator';
import HelloWorld from './components/HelloWorld.vue';

@Component({
  components: {
    HelloWorld,
  },
})
export default class App extends Vue
{
    error: string | null = null;

    showAdvanced: boolean = false;
    isDropping: boolean = false;

    previewImg: string = "";
    outputImg: string = "";
    
    threshold: number = 3;
    keepTransparency: boolean = true;
    preblur: number = 0.001;

    get previewRawBase64(): string
    {
        return this.previewImg.substring(this.previewImg.indexOf(",") + 1);
    }

    mounted()
    {
        var self = this;

        window.addEventListener("dragover", function (e: DragEvent)
        {
            e.preventDefault();
            self.isDropping = true;
        });

        window.addEventListener("dragleave", function (e: DragEvent)
        {
            e.preventDefault();
            self.isDropping = false;
        });

        window.addEventListener("drop", function (e: DragEvent)
        {
            e.preventDefault();

            if (e.dataTransfer.files.length < 1)
            {
                self.error = "That's not an image file";
                self.isDropping = false;
                return;
            }

            let file = e.dataTransfer.files[0];
            self.selectFile(file);

            self.isDropping = false;
        });
    }

    selectFile(file: File)
    {
        var image = new Image();
        var self = this;

        if (file.size > 5000000)
        {
            self.error = "File's too big - must be under 5mb";
            return;
        }

        image.onload = function()
        {
            self.loadFile(file);
            image.remove();
            self.error = "";
        };

        image.onerror = function()
        {
            self.error = "That's not a valid image";
            image.remove();
        }

        console.log(file);

        image.src = URL.createObjectURL(file);
    }

    loadFile(file: File)
    {
        var reader = new FileReader();
        var self = this;

        reader.onload = (e: Event) =>
        {
            self.previewImg = (<FileReader>e.target).result;
        };

        reader.readAsDataURL(file);
    }

    onFileChange(e: Event)
    {
        var target = (<HTMLInputElement>e.target);
        var files = target.files;

        if (!files || !files.length)
        {
            return;
        }

        this.selectFile(files[0]);
    }

    blurple()
    {
        this.error = "";
        let self = this;

        fetch("https://blurpler.azurewebsites.net/api/ImageTransformer",
        {
            headers:
            {
                'Accept': 'image/png',
                'Content-Type': 'application/json'
            },
            method: "POST",
            body: JSON.stringify(
            {
                Threshold: self.threshold, 
                KeepTransparency: self.keepTransparency, 
                Preblur: self.preblur, 
                ImageBase64: self.previewRawBase64
            })
        })
        .then(async function(res)
        {
            if (!res.ok)
            {
                self.error = await res.text();
                return;
            }

            var reader = new FileReader();

            reader.onload = (e: Event) =>
            {
                self.outputImg = (<FileReader>e.target).result;
            };

            let result = await res.blob();

            if (result)
            {
                reader.readAsDataURL(result);
            }
        })
        .catch(function(res)
        {
            self.error = res;
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue